module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Support games","more":"and more"},"zhHant":{"title":"支援遊戲","more":"看更多"},"ja":{"title":"対応ゲーム","more":"ほかのゲームも見る"},"ko":{"title":"지원하는 게임","more":"더보기"}}')
  delete Component.options._Ctor
}
